import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "error-area" }
const _hoisted_2 = { class: "d-table" }
const _hoisted_3 = { class: "d-table-cell" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "error-content text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("h1", null, [
              _createTextVNode("4"),
              _createElementVNode("span", null, "0"),
              _createTextVNode("4")
            ], -1)),
            _cache[2] || (_cache[2] = _createElementVNode("h3", null, "Oops! page is not found", -1)),
            _cache[3] || (_cache[3] = _createElementVNode("p", null, "Sorry, but the page you are looking for does not exist.", -1)),
            _createVNode(_component_RouterLink, {
              to: "/",
              class: "btn btn-warning text-white"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("span", null, "Back To Homepage", -1),
                _createElementVNode("i", { class: "ti ti-home" }, null, -1)
              ])),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}